// @flow

import fieldsModuleMapping from '../config/fieldsModuleMapping';

const getIdFieldMapping = (moduleName: string) => {
  const mapping = fieldsModuleMapping[moduleName];

  if (!mapping) {
    return '';
  }

  const { id: fieldName } = mapping;

  return fieldName;
};

export { getIdFieldMapping };
